/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import * as React from 'react';
import {
  createStackNavigator,
  CardStyleInterpolators,
} from '@react-navigation/stack';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { isWeb } from '@global/screens';
import {
  setTitleHeader,
  setDefaultStackOption,
  hasNoAccess,
} from '@global/helpers';

import HamburgerButton from '@components/navbar/HamburgerButton';
import NotificationSettingButton from '@components/navbar/NotificationSettingButton';
import BackButton from '@components/navbar/BackButton';
import ActionButton from '@components/navbar/ActionButton';

import NewArrivalBestSellerScreen from '@/screens/setting/new-arrival-best-seller/NewArrivalBestSellerScreen';
import NewArrivalBestSellerDetailScreen from '@/screens/setting/new-arrival-best-seller/NewArrivalBestSellerDetailScreen';
import NewArrivalBestSellerFormScreen from '@/screens/setting/new-arrival-best-seller/NewArrivalBestSellerFormScreen';

const Stack = createStackNavigator();

const NewArrivalBestSellerNavigator = ({ navigation }) => {
  const insets = useSafeAreaInsets();

  const showAddButton = hasNoAccess([
    'sales_supervisor',
    'branch_head',
    'finance_supervisor',
    'regional_manager',
    'regional_support',
    'key_account_manager',
    'group_key_account_manager',
    'national_key_account_manager',
    'distributor_manager',
    'general_manager',
    'vice_president',
    'vice_president_finance',
    'budget_controller',
    'finance_head',
    'tax_support',
    'billing_supervisor',
    'regional_distributor_manager',
  ]);

  return (
    <Stack.Navigator
      initialRouteName="NewArrivalBestSellerScreen"
      screenOptions={(props) => ({
        headerLeft: () => <HamburgerButton {...props} />,
        headerRight: () => <NotificationSettingButton {...props} />,
        ...setDefaultStackOption(insets, CardStyleInterpolators),
      })}>
      <Stack.Screen
        name="NewArrivalBestSellerScreen"
        component={NewArrivalBestSellerScreen}
        options={() => ({
          // headerRight (incl. the mobile Add) is owned by the screen so Add goes
          // through openChild and preserves the list on return.
          title: setTitleHeader('Best Seller/New Arrival'),
        })}
      />
      <Stack.Screen
        name="NewArrivalBestSellerFormScreen"
        component={NewArrivalBestSellerFormScreen}
        options={(props) => {
          const route = props.route;
          let title = 'Add Best Seller/New Arrival';
          let params = {};
          let isEdit = false;
          if (route.params && route.params.titleScreen) {
            title = route.params.titleScreen;
            params = route.params;
            isEdit = true;
          }
          return {
            title: setTitleHeader(title),
            headerLeft: () => (
              <BackButton
                {...props}
                isJump={true}
                customBack={{
                  screen: isEdit
                    ? 'NewArrivalBestSellerDetailScreen'
                    : 'NewArrivalBestSellerScreen',
                  params: params,
                }}
              />
            ),
            headerRight: () =>
              isWeb ? <NotificationSettingButton {...props} /> : false,
          };
        }}
      />
      <Stack.Screen
        name="NewArrivalBestSellerDetailScreen"
        component={NewArrivalBestSellerDetailScreen}
        options={(props) => {
          const route = props.route;
          let title = 'Best Seller/New Arrival';
          if (route.params && route.params.titleScreen) {
            title = route.params.titleScreen;
          }
          return {
            title: setTitleHeader(title),
            headerLeft: () => (
              <BackButton
                {...props}
                // navigate() to the list (not pop) so back survives a browser
                // refresh, where the list isn't in the fresh stack.
                onPress={() =>
                  props.navigation.navigate('NewArrivalBestSellerScreen')
                }
              />
            ),
            headerRight: () =>
              isWeb ? (
                <NotificationSettingButton {...props} />
              ) : showAddButton ? (
                <ActionButton
                  icon={require('@assets/img/icons/edit-white.svg')}
                  onCallback={() =>
                    props.navigation.navigate(
                      'NewArrivalBestSellerFormScreen',
                      props?.route?.params,
                    )
                  }
                />
              ) : (
                false
              ),
          };
        }}
      />
    </Stack.Navigator>
  );
};

export default NewArrivalBestSellerNavigator;
